/* eslint-disable no-plusplus */
import VerticalAdBreaks from '@/models/ad-schedules/VerticalAdBreaks'
import WaterfallTagUrl from '@/models/ad-schedules/AdBreakTagURL'

const mutations = {
  SET_VERTICAL_AD_BREAKS: (state, { adScheduleId, data }) => {
    let { verticalAdBreaks } = state
    verticalAdBreaks = []
    let verticalAdBreak

    if (data && data.length > 0) {
      data.forEach((m, i) => {
        verticalAdBreak = new VerticalAdBreaks()
        verticalAdBreak.fromData(m)
        verticalAdBreaks.splice(i, 0, verticalAdBreak)
      })
    } else {
      // If no data is provided, create a single placeholder AdBreak
      verticalAdBreak = new VerticalAdBreaks(adScheduleId, null, null)
      verticalAdBreaks.push(verticalAdBreak)
    }

    state.verticalAdBreaks = verticalAdBreaks
  },
  SET_EXISTING_AD_BREAK: (state, { data }) => {
    const { verticalAdBreaks } = state
    const adBreakIndex = verticalAdBreaks.findIndex(y => y.id === data.id) || 0
    const nab = new VerticalAdBreaks()
    nab.fromData(data)
    verticalAdBreaks.splice(adBreakIndex, 1, nab)
  },
  SET_CREATED_VERTICAL_AD_BREAK: (state, {
    data, adBreakIndex,
  }) => {
    const { verticalAdBreaks } = state
    const nab = new VerticalAdBreaks()
    nab.fromData(data)
    verticalAdBreaks.splice(adBreakIndex, 1, nab)
  },
  ADD_TAG_URL(state, data) {
    state.verticalAdBreaks[data.adBreakIndex].waterfallTags.push(new WaterfallTagUrl())
  },
  UPDATE_WATERFALL_TAG_URL: (state, data) => {
    state.verticalAdBreaks[data.adBreakIndex].waterfallTags[data.tagUrlIndex].waterfallTagUrl = data.url
  },
  ADD_AD_BREAK: (state, { adScheduleId, type, id }) => {
    state.verticalAdBreaks.push(new VerticalAdBreaks(adScheduleId, type, id))
  },
  CLEAR_AD_BREAK_ON_INDEX: (state, {
    adBreakType, adBreakIndex, adScheduleId, adBreakTypeName,
  }) => {
    state.verticalAdBreaks.splice(
      adBreakIndex,
      1,
      new VerticalAdBreaks(adScheduleId, adBreakTypeName, adBreakType),
    )
  },

  REMOVE_AD_BREAK: (state, {
    adBreakTypeId, adBreakIndex, adBreakTypeName, adScheduleId,
  }) => {
    const { verticalAdBreaks } = state
    const filtered = verticalAdBreaks.filter(y => y.adBreakTypeId === adBreakTypeId)
    if (filtered.length <= 1) {
      verticalAdBreaks.splice(
        adBreakIndex,
        1,
        new VerticalAdBreaks(adScheduleId, adBreakTypeName, adBreakTypeId),
      )
    } else {
      verticalAdBreaks.splice(adBreakIndex, 1)
    }
  },
  REMOVE_TAG_URL(state, data) {
    state.verticalAdBreaks[data.adBreakIndex].waterfallTags[data.tagUrlIndex].isDeleted = true
  },
}

export default mutations
